<!--  -->
<!--
  开通服务弹窗（进项管理「立即抵扣」未开通时弹出）。
  设计稿：ops/ETC进项页面/开通服务弹窗-活动.html（活动版文案：888 元/年限时价）。
  交互：点「立即抵扣」经 POST /api/jxgl/entry-click 判定未开通 → 弹本窗；
  「立即咨询开通」→ POST /api/intention 记录客户请求 → 成功提示
  「已通知服务您的销售，稍后会和您联系」并关闭；失败留在弹窗内可重试。
-->
<template>
    <el-dialog
        :visible="show"
        :show-close="false"
        width="420px"
        custom-class="service-open-dialog"
        @update:visible="$emit('update:show', $event)"
    >
        <div class="modal">
            <button
                class="close"
                title="关闭"
                @click="close"
            >
                <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.2"
                    stroke-linecap="round"
                ><path d="M18 6L6 18M6 6l12 12" /></svg>
            </button>

            <div class="head">
                <div class="head-ico">
                    <svg
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ><path d="M3 12a9 9 0 0 1 18 0" /><path d="M3 12v4a2 2 0 0 0 2 2h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H3zM21 12v4a2 2 0 0 1-2 2h-1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3z" /><path d="M21 17v1a3 3 0 0 1-3 3h-4" /></svg>
                </div>
                <div class="title">
                    开通服务，让发票管理更省心
                </div>
                <div class="title-sub">
                    限时优惠中，现在开通立省 ¥4,400
                </div>
            </div>

            <div class="body">
                <div class="row">
                    <span class="num">1</span>
                    <span class="row-text">开通后即可使用<b>发票抵扣</b>与<b>发票归集</b>，减少手动整理，让日常发票处理更高效。</span>
                </div>
                <div class="row">
                    <span class="num">2</span>
                    <span class="row-text">活动价仅<b>888元/年</b>，服务期限<b>1年</b>。每日限<b>10个优惠名额</b>，活动截止后恢复至<b>5288元/年</b>。</span>
                </div>
            </div>

            <div class="price-row">
                <span class="price-label">限时活动价</span>
                <span class="price"><span class="cur">¥</span>888</span>
                <span class="price-unit">/ 年</span>
                <span class="price-original">原价 ¥5,288</span>
            </div>

            <div class="foot">
                <el-button
                    class="btn-try"
                    :loading="submitting"
                    @click="handleTryClick"
                >
                    立即咨询开通
                </el-button>
                <div class="foot-tip">
                    优惠名额有限，联系销售或客服即可办理
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { submitIntention } from '@/api/tickHub'

export default {
    name: 'service-open-dialog',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        // 意向事件来源标识（区分 dealer 工作台 / 泛域名门户两处入口）
        source: {
            type: String,
            default: 'trial-click'
        }
    },
    data () {
        return {
            submitting: false
        }
    },
    methods: {
        close () {
            if (!this.submitting) {
                this.$emit('update:show', false)
            }
        },
        // 立即咨询开通：记录客户请求，成功后提示并关闭（失败留在弹窗内可重试）
        async handleTryClick () {
            if (this.submitting) {
                return
            }
            this.submitting = true
            try {
                await submitIntention(this.source)
                this.$message({
                    message: '已通知服务您的销售，稍后会和您联系',
                    type: 'success',
                    showClose: true,
                    duration: 3 * 1000
                })
                this.$emit('update:show', false)
            } catch (e) {
                // 错误提示已由 tickHub 响应拦截器统一弹出，这里留在弹窗内可重试
            } finally {
                this.submitting = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
$red: #d9363e;
$red-deep: #c22a30;
$red-soft: #fdf1f1;
$ink: #2a2f3a;
$text: #33383f;
$muted: #8a9099;
$line: #eceef2;

// 设计稿 .modal：顶部 4px 红色渐变装饰条 + 圆角弹窗
/deep/ .service-open-dialog {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.28);
}

/deep/ .el-dialog__header,
/deep/ .el-dialog__body {
    padding: 0;
}

.modal {
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(90deg, #e8493f, $red-deep);
    }

    .close {
        position: absolute;
        top: 14px;
        right: 16px;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #b6bdc9;
        cursor: pointer;
        transition: 0.2s;
        border: none;
        background: transparent;
        z-index: 1;

        &:hover {
            background: $red-soft;
            color: $red;
            transform: rotate(90deg);
        }
    }

    .head {
        text-align: center;
        padding: 34px 28px 0;

        .head-ico {
            width: 62px;
            height: 62px;
            margin: 0 auto 16px;
            border-radius: 50%;
            position: relative;
            background: $red-soft;
            display: flex;
            align-items: center;
            justify-content: center;
            color: $red;

            // 设计稿虚线圆环缓转装饰
            &::after {
                content: '';
                position: absolute;
                inset: -6px;
                border-radius: 50%;
                border: 1px dashed #f3c0be;
                animation: svc-ring-spin 14s linear infinite;
            }
        }

        .title {
            font-size: 17px;
            font-weight: 700;
            color: $ink;
            letter-spacing: 0.3px;
        }

        .title-sub {
            margin-top: 7px;
            font-size: 12px;
            color: $red;
            background: $red-soft;
            display: inline-block;
            padding: 2px 12px;
            border-radius: 20px;
        }
    }

    .body {
        padding: 22px 30px 4px;
        display: flex;
        flex-direction: column;
        gap: 12px;

        .row {
            display: flex;
            align-items: flex-start;
            gap: 11px;
            background: #f8f9fb;
            border: 1px solid $line;
            border-radius: 10px;
            padding: 12px 14px;

            .num {
                flex-shrink: 0;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: linear-gradient(135deg, #e8493f, $red-deep);
                color: #fff;
                font-size: 12px;
                font-weight: 700;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 1px;
                box-shadow: 0 2px 5px rgba(217, 54, 62, 0.3);
            }

            .row-text {
                font-size: 13px;
                color: $text;
                line-height: 1.75;

                b {
                    color: $red;
                    font-weight: 700;
                }
            }
        }
    }

    .price-row {
        display: flex;
        align-items: baseline;
        justify-content: center;
        gap: 6px;
        padding: 16px 0 2px;

        .price-label {
            font-size: 12.5px;
            color: $muted;
        }

        .price {
            font-size: 30px;
            font-weight: 800;
            color: $red;
            font-variant-numeric: tabular-nums;
            line-height: 1;

            .cur {
                font-size: 15px;
                font-weight: 600;
                margin-right: 2px;
            }
        }

        .price-unit {
            font-size: 12.5px;
            color: #5a6070;
        }

        .price-original {
            font-size: 11.5px;
            color: $muted;
            text-decoration: line-through;
            margin-left: 2px;
            white-space: nowrap;
        }
    }

    .foot {
        padding: 16px 30px 26px;

        .btn-try {
            width: 100%;
            height: 42px;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            background: linear-gradient(135deg, #e8493f, $red-deep);
            color: #fff;
            font-size: 14.5px;
            font-weight: 600;
            letter-spacing: 4px;
            transition: 0.2s;
            box-shadow: 0 6px 14px rgba(217, 54, 62, 0.32);

            &:hover,
            &:focus {
                filter: brightness(1.07);
                transform: translateY(-1px);
                box-shadow: 0 8px 18px rgba(217, 54, 62, 0.4);
                background: linear-gradient(135deg, #e8493f, $red-deep);
                color: #fff;
            }

            &:active {
                transform: translateY(0);
            }
        }

        .foot-tip {
            margin-top: 10px;
            text-align: center;
            font-size: 11.5px;
            color: $muted;
        }
    }
}

@keyframes svc-ring-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
